module.exports = __webpack_public_path__ + "static/img/11.240672f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/helpModals/budget/11.png
// module id = MAVE
// module chunks = 1